var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBadge2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 112,
    viewBox: "0 0 120 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_287_4420)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2679 95C30.9516 95 24.1346 91.0693 20.4766 84.7415L5.74444 59.2582C2.08616 52.9307 2.08616 45.0693 5.74444 38.7418L20.4769 13.2582C24.1346 6.9307 30.9519 3 38.2679 3H67.7328C75.0491 3 81.8661 6.9307 85.5241 13.2582L100.257 38.7418C103.915 45.0693 103.915 52.9307 100.257 59.2582L85.5241 84.7418C81.8664 91.0693 75.0491 95 67.7328 95H38.2679Z",
    fill: "url(#paint0_linear_287_4420)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2674 92.6651C31.7837 92.6651 25.7425 89.1818 22.5011 83.5745L7.76863 58.0909C4.52667 52.4836 4.52667 45.5167 7.76863 39.9094L22.5011 14.4258C25.7425 8.81849 31.784 5.33521 38.2674 5.33521H67.7323C74.2159 5.33521 80.2572 8.81849 83.4986 14.4258L98.231 39.9094C101.473 45.5167 101.473 52.4836 98.231 58.0909L83.4986 83.5745C80.2572 89.1818 74.2156 92.6651 67.7323 92.6651H38.2674Z",
    fill: "url(#paint1_linear_287_4420)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.2
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.256 38.7424L85.5234 13.2579C81.8666 6.92986 75.0487 3 67.7327 3H38.2678C30.9518 3 24.1339 6.92986 20.4771 13.2576L5.74434 38.7424C2.08522 45.0701 2.08522 52.9299 5.74434 59.2579L20.4768 84.7424C24.1337 91.0701 30.9515 95 38.2675 95H67.7324C75.0484 95 81.8663 91.0701 85.5232 84.7424L100.256 59.2579C103.915 52.9301 103.915 45.0704 100.256 38.7424H100.256ZM98.2312 58.0903L83.4987 83.5748C80.2582 89.1812 74.2163 92.6651 67.7327 92.6651H38.2678C31.7842 92.6651 25.7426 89.1812 22.5018 83.5748L7.76933 58.0903C4.52624 52.4838 4.52624 45.5162 7.76933 39.9099L22.5018 14.4255C25.7423 8.81904 31.7842 5.33519 38.2678 5.33519H67.7327C74.2163 5.33519 80.2579 8.81904 83.4987 14.4255L98.2312 39.9099C101.474 45.5164 101.474 52.4841 98.2312 58.0903Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2674 90.3299C32.6167 90.3299 27.3511 87.2941 24.5258 82.4066L9.79334 56.923C6.96798 52.0359 6.96798 45.9639 9.79334 41.0764L24.5258 15.5929C27.3511 10.7057 32.6164 7.66956 38.2674 7.66956H67.7323C73.383 7.66956 78.6485 10.7054 81.4739 15.5929L96.2063 41.0764C99.0317 45.9636 99.0317 52.0356 96.2063 56.923L81.4739 82.4066C78.6485 87.2938 73.3833 90.3299 67.7323 90.3299H38.2674Z",
    fill: "url(#paint2_linear_287_4420)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2676 87.995C33.4495 87.995 28.96 85.4063 26.5509 81.2393L11.8185 55.7557C9.40946 51.5887 9.40946 46.4113 11.8185 42.2443L26.5509 16.7607C28.96 12.5937 33.4495 10.005 38.2676 10.005H67.7325C72.5505 10.005 77.04 12.5937 79.4491 16.7607L94.1815 42.2443C96.5906 46.4113 96.5906 51.5887 94.1815 55.7557L79.4491 81.2393C77.04 85.4063 72.5505 87.995 67.7325 87.995H38.2676Z",
    fill: "url(#paint3_linear_287_4420)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1565 54.5879L88.6213 60.7008L77.424 80.0723C75.4248 83.5304 71.7306 85.6601 67.7324 85.6601H38.2675C34.2693 85.6601 30.5751 83.5304 28.5759 80.0723L27.8511 78.8185L24.6337 73.2541L13.8434 54.5879C11.8442 51.1297 11.8442 46.8706 13.8434 43.4125L27.049 20.5713L28.5759 17.928C30.5751 14.4699 34.2693 12.3402 38.2675 12.3402H67.7324C71.7306 12.3402 75.4248 14.4699 77.424 17.928L81.4737 24.933L92.1565 43.4125C94.1557 46.8706 94.1557 51.1297 92.1565 54.5879Z",
    fill: "url(#paint4_linear_287_4420)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.1
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1563 54.5878L88.6211 60.7008L27.0491 20.5709L28.5759 17.9277C30.5752 14.4696 34.2694 12.3398 38.2676 12.3398H67.7325C71.7307 12.3398 75.4249 14.4696 77.4241 17.9277L92.1566 43.4121C94.1558 46.8702 94.1558 51.1294 92.1566 54.5875L92.1563 54.5878Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.15
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4737 24.9327L27.8513 78.8181L13.8437 54.5875C11.8444 51.1294 11.8444 46.8702 13.8437 43.4121L27.0492 20.5709L28.5761 17.9277C30.5753 14.4696 34.2696 12.3398 38.2677 12.3398H67.7326C71.7308 12.3398 75.425 14.4696 77.4243 17.9277L81.474 24.9327H81.4737Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.1
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4458 12.3402C45.2889 27.3917 29.8854 61.5742 24.6337 73.2541L13.8434 54.5879C11.8442 51.1297 11.8442 46.8706 13.8434 43.4125L27.049 20.5713L28.5759 17.928C30.5751 14.4699 34.2693 12.3402 38.2675 12.3402H52.4458Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_287_4420",
    x: 0,
    y: 0,
    width: 120,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.239216 0 0 0 0 0.219608 0 0 0 0 0.219608 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_287_4420"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_287_4420",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_287_4420",
    x1: 10.723,
    y1: 20.6612,
    x2: 95.2383,
    y2: 77.4628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#888888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_287_4420",
    x1: 12.8259,
    y1: 22.071,
    x2: 93.1365,
    y2: 76.0467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#888888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_287_4420",
    x1: 14.929,
    y1: 23.4808,
    x2: 91.0351,
    y2: 74.6307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1E9E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_287_4420",
    x1: 17.0325,
    y1: 24.8906,
    x2: 88.934,
    y2: 73.2148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_287_4420",
    x1: 19.1356,
    y1: 26.3005,
    x2: 86.8329,
    y2: 71.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#888888"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge2);
export default __webpack_public_path__ + "static/media/badge-2.69a54f0b8a7c1e4e473927bffd28d6c5.svg";
export { ForwardRef as ReactComponent };